'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _styles = require('../../../common/styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var colors = _styles2.default.colors;

var columnStyle = {
	display: 'flex',
	flexFlow: 'column nowrap',
	margin: '0 0 2em'
};
var columnLeftStyle = _extends({}, columnStyle, {
	width: '33%',
	minWidth: '200px',
	margin: '1em 1em 0 0'
});
var columnRightStyle = _extends({}, columnStyle, {
	width: '56%',
	minWidth: '200px'
});
var columnFullStyle = _extends({}, columnStyle, {
	width: '89%',
	justifyContent: 'space-around'
});

var _default = {
	container: {
		width: '100%',
		padding: '2em 1.86em',
		minHeight: '14.43em',
		margin: '0 0 2em'
	},
	columns: {
		display: 'flex',
		flexFlow: 'row wrap',
		alignItems: 'flex-start',
		justifyContent: 'space-around'
	},
	getColumnStyle: function getColumnStyle() {
		var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';

		if (direction === 'left') {
			return columnLeftStyle;
		} else if (direction === 'none') {
			return columnFullStyle;
		}
		return columnRightStyle;
	},
	overviewItem: {
		display: 'flex',
		flexFlow: 'row nowrap',
		justifyContent: 'flex-start',
		padding: '0.5em 0'
	},
	overviewItemIcon: {
		fontSize: '2.2em'
	},
	overviewItemLabel: {
		color: colors.grey,
		margin: '0 0 0 0.86em',
		fontSize: '1em'
	},
	overviewText: {
		fontSize: '1em'
	},
	avatar: {
		maxWidth: '100%',
		maxHeight: '6.5em'
	},
	followButton: {
		width: '160px',
		borderRadius: '2px',
		backgroundColor: '#53b3f3',
		boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)'
	},
	followButtonLabel: {
		fontSize: '14px',
		color: '#ffffff'
	},
	blockButton: {
		width: '160px',
		borderRadius: '2px',
		backgroundColor: '#53b3f3',
		boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
		marginLeft: '1em',
		whiteSpace: 'noWrap'
	},
	blockButtonLabel: {
		fontFamily: 'OpenSans',
		fontSize: '14px',
		color: '#ffffff'
	},
	actionContainer: {
		float: 'right'
	},
	followButtonColors: {
		follow: '#53b3f3',
		following: '#5bc75d'
	}
};
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(colors, 'colors', 'src/components/WMCompanyPageOverview/styles/index.js');

	__REACT_HOT_LOADER__.register(columnStyle, 'columnStyle', 'src/components/WMCompanyPageOverview/styles/index.js');

	__REACT_HOT_LOADER__.register(columnLeftStyle, 'columnLeftStyle', 'src/components/WMCompanyPageOverview/styles/index.js');

	__REACT_HOT_LOADER__.register(columnRightStyle, 'columnRightStyle', 'src/components/WMCompanyPageOverview/styles/index.js');

	__REACT_HOT_LOADER__.register(columnFullStyle, 'columnFullStyle', 'src/components/WMCompanyPageOverview/styles/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMCompanyPageOverview/styles/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/components/WMCompanyPageOverview/styles/index.js
// module id = nsQX
// module chunks = 62 63